import styles from "./StudioRelationsWizard.module.scss";
import { FormProvider } from "react-hook-form";
import { SingleSectionPageLayout } from "../../../../common/components/common/SingleSectionPageLayout";
import { IStudioRelationsWizardFormModel } from "./models/studioRelationsWizardFormModel";
import { nameof } from "ts-simple-nameof";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { useStudioRelationsWizardPage } from "./hooks/useStudioRelationsWizardPage";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { Icon, IconType } from "../../../../common/icons/Icon";
import { SpecificPageNotFound } from "../../../../common/components/errorPages/SpecificPageNotFound";
import { useNavigate } from "react-router-dom";
import { getDefaultRoutePath } from "../../../../common/infrastructure/routes/routePaths";
import { useAppContext } from "../../../../AppContext";
import { UserRole } from "../../../../common/enums";
import { ErrorPage } from "../../../../common/components/errorPages/ErrorPage";
import { getCurrentUserRole } from "../../../../common/infrastructure/helpers/userHelper";

interface IStudioRelationsWizardProps {}

export const StudioRelationsWizard = ({}: IStudioRelationsWizardProps) => {
  const { form, isStudiosLoading, allStudios, onSave } =
    useStudioRelationsWizardPage();
  const { currentUser } = useAppContext();

  const navigate = useNavigate();

  const mainStudio = form.watch("firstStudioId");

  if (!allStudios) {
    return <ErrorPage />;
  }

  const children = (
    <>
      <div className={styles.root_fields}>
        <DefaultFormSelectField
          className={styles.root_section_inner_container_duration_dropdown}
          name={nameof<IStudioRelationsWizardFormModel>((x) => x.firstStudioId)}
          options={allStudios}
        />

        <Icon
          type={IconType.ArrowRight}
          className={styles.root_arrow}
          width="50px"
          height="50px"
        />

        <DefaultFormSelectField
          className={styles.root_section_inner_container_duration_dropdown}
          name={nameof<IStudioRelationsWizardFormModel>(
            (x) => x.secondStudioId,
          )}
          options={allStudios?.filter((x) => x.id !== mainStudio)}
        />
      </div>
      <div className={styles.root_buttons}>
        <DefaultButton label={"Добави"} type="submit" />
      </div>
    </>
  );

  if (getCurrentUserRole(currentUser) === UserRole.GlobalAdmin) {
    return (
      <SpecificPageNotFound
        text={"Тази страница все още не е готова."}
        buttonText={"Към Календара"}
        onButtonClick={() => navigate(getDefaultRoutePath(currentUser))}
      />
    );
  }

  if (!allStudios || allStudios.length < 2) {
    return (
      <SpecificPageNotFound
        text={"За съжаление нямате достатъчно обекти."}
        buttonText={"Към Kалендара"}
        onButtonClick={() => navigate(getDefaultRoutePath(currentUser))}
      />
    );
  }
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSave)}>
        <SingleSectionPageLayout
          title={"Добавяне на свързан обект"}
          maxHeight={"60%"}
          children={children}
        />
      </form>
    </FormProvider>
  );
};
